export const Home = "/";
export const GroupNumber = "/:url_params_group_number";
export const DrugDetails = "/find-best-price/drug-details";
export const PriceList = "/find-best-price/price-list";
export const PharmacyDetails = "/find-best-price/pharmacy-details";
export const TermsAndConditions = "/terms-and-conditions";
export const PrivacyPolicy = "/privacy-policy";

export const Client = "/client/:client";
export const WhiteLabelDrugDetails = "/client/:client/find-best-price/drug-details";
export const WhiteLabelPriceList = "/client/:client/find-best-price/price-list";
export const WhiteLabelPharmacyDetails = "/client/:client/find-best-price/pharmacy-details";
